var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "placementarea" }, [
      _c("span", [_vm._v("组件放置区域")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }